// extracted by mini-css-extract-plugin
export default {"root":"LoadingCover_root__WKGOi","cover":"LoadingCover_cover__Z9z8+","loader":"LoadingCover_loader__WMiq9","glass":"LoadingCover_glass__X+7Uw","active":"LoadingCover_active__Db2Q-"};